// src/components/PaymentModal.js

import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, TextField, Grid } from '@mui/material';

const PaymentModal = ({ open, handleClose }) => {
  const handlePayment = () => {
    // Implement your payment processing logic here
    // For example, integrate with Stripe or another payment gateway
    alert('Payment submitted!');
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Make a Payment</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Please enter your payment details below.
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField label="Card Number" variant="outlined" fullWidth />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Expiry Date" variant="outlined" fullWidth placeholder="MM/YY" />
          </Grid>
          <Grid item xs={6}>
            <TextField label="CVC" variant="outlined" fullWidth placeholder="123" />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handlePayment} color="primary" variant="contained">
          Pay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentModal;

